import { useContext, useEffect, useRef, useState } from "react";
import TableDashboardPdf from "../../components/generic/tableDashboardPdf";
import React from "react";
import PieChart from "../../components/charts/pieChart";
import BarChart from "../../components/charts/barChart";
import { Box, Button, Grid, Typography } from "@mui/material";
import { AuthContext } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import BoxTheme from "../../components/generic/box";
import { ThemeContext } from "../../contexts/ThemeContext";
import { useReactToPrint } from "react-to-print";
import bannertop from "../../assets/bannertop.png";
import PrintIcon from "@mui/icons-material/Print";
import CardHeader from "../../components/generic/cardHeaderDashboard";
import CardHeaderPreviewPdf from "../../components/generic/cardHeaderPreviewPdf";
import CardBasicPdf from "../../components/generic/cardPdf";
import { useSearchParams } from "react-router-dom";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";
import PrintPdfWarning from "../../components/generic/modalPrintPdfWarning";
import Confirmation from "../../components/generic/confirmation";
import { api } from "../../services/api";
import { apiUrl } from "../../services/apiUrl";
import notImage from "../../assets/sem-foto.png";
import "./index.css"
import { styled } from '@mui/material/styles';
import CardBasicPdf2 from "../../components/generic/cardPdf";

export default function PreviewPdfEstatisc() {

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const { menu } = useContext(ThemeContext);
  const { user } = useContext(AuthContext);
  const [visiblePdf, setVisiblePdf] = useState(false);
  const userPdfEmit = user.email;
  const agora = new Date().toLocaleDateString("pt-Br");
  const dashboardTodo = useRef();
  const [modal, setModal] = useState(false);
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  const [report1, setReport1] = useState();
  const [report2, setReport2] = useState();
  const [report3, setReport3] = useState();
  // const [enterprise, setEnterprise] = useState();

  const enterprise = localStorage.getItem("PreviewPDFClient");
  let enterpriseWidth;
  JSON.parse(enterprise).length > 3 ? enterpriseWidth = 270 / (JSON.parse(enterprise).length) : enterpriseWidth = 60;

  const handlePdf = useReactToPrint({
    content: () => dashboardTodo.current,
  });



  const MakePdf = async () => {
    // handleLoading(true);
    // setVisiblePdf(true);
    // await sleep(2000);
    handlePdf();
    // await sleep(500);
    // setVisiblePdf(false);
    // handleLoading(false);
  };

  const idEnterprise = { id_client: JSON.parse(localStorage.getItem("clientIdPdfEstatistico")) }

  // const getEnterpriseById = async (data) => {
  //   try {
  //     const { data: response } = await api({
  //       method: "POST",
  //       url: "/source/client",
  //       data,
  //     });
  //     setEnterprise(response)
  //   } catch (err) {}
  // };

  const getFinancial = async (data) => {

    try {
      const { data: response } = await api({
        method: "POST",
        url: "/source/dashboard/financial",
        data
      });
      setReport1(response)
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
  }

  const getBaixas = async (data) => {
    try {
      const { data: response } = await api({
        method: "POST",
        url: "/source/dashboard/baixas",
        data
      });
      setReport2(response)
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
  }
  const getAcordos = async (data) => {
    try {
      const { data: response } = await api({
        method: "POST",
        url: "/source/dashboard/acordos",
        data
      });
      setReport3(response)
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
  }


  const getResumo2 = async (data, enterpriseSelected) => {
    handleLoading(true);
    try {
      const idClient = enterpriseSelected
      let data = idClient
      const { data: response } = await api({ method: 'POST', url: '/source/resumo', data });

      const resultados = response?.resultados
      const baixas = response?.baixas
      const total = response?.total
      const resumo = response?.resumo
      setReport1(total)
      setReport2(baixas)
      setReport3(resultados)

    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);

  }
  useEffect(() => {
    // getFinancial(idEnterprise)
    // getBaixas(idEnterprise)
    getResumo2(null, idEnterprise)
  }, [])

  return (
    <Box component="main" sx={{ flexGrow: 1, p: 5, height: '100vh', overflow: 'auto' }}>
      <Grid
        container
        spacing={2}
        columns={20}
        sx={{ marginTop: "2px" }}
      >
        <Grid xs={18}>
          <Typography
            sx={{ marginLeft: "20px", fontSize: 20, color: "#4B4B4B" }}
          >
            Visualização de impressão
          </Typography>
        </Grid>
        <Grid xs={1}>
          <Button
            onClick={() => setModal(true)}
            color="blueSys"
            variant="contained"
            sx={{
              // backgroundColor: "#0032A0",
              width: "30px",
              height: "50px",
              marginLeft: "15px",
            }}
          >
            <PrintIcon />
          </Button>
          <PrintPdfWarning
            handleClose={() => {
              setModal(false);
            }}
            open={modal}
            handlePDFEmit={() => {
              MakePdf();
              setModal(false);
            }}
          ></PrintPdfWarning>
        </Grid>
      </Grid>
      <div style={{
        height: "900px",
        padding: "16px",
        width: "1440px",
        display: 'inline-block',
      }} ref={dashboardTodo}> <Box p={8}>
          <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            <Grid sx={{ marginLeft: "15px" }}>
              <img
                src={bannertop}
                style={{
                  width: "60%",
                  height: "90%",
                  padding: "10px",
                  marginLeft: "10px",
                }}
              ></img>
            </Grid>
            <Grid
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                justifyContent: "center",
                marginLeft: "75px",
              }}
            >
              <Typography
                sx={{ fontSize: 22, fontWeight: "bold", color: "#4B4B4B" }}
              >
                Relatório Estatístico
              </Typography>
              <Typography
                sx={{
                  color: "#5E5E5E",
                }}
              >
                Relatório de acompanhamento da carteira
              </Typography>
            </Grid>
            <Grid>
              <Grid item xs={12} sx={{
                display: "flex",
                alignItems: "start",
                justifyContent: "right",
                marginLeft: "155px",
                marginTop: "15px"
              }}>
                {JSON.parse(enterprise).map((head, index) => (
                  <>
                    <img
                      src={
                        !!head?.logo_file
                          ? `${apiUrl}/files/${head.logo_file}`
                          : notImage
                      }
                      style={{ width: enterpriseWidth, marginLeft: "32px", maxHeight: "35px", float: "Right" }}
                      alt="banner"
                    />
                  </>
                ))}
              </Grid>
            </Grid>
          </Grid>
          <Grid></Grid>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "#01A7E1",
              width: "100%"
            }}
          ></Box>
          <Grid>
            <CardHeaderPreviewPdf enterpriseData={enterprise}></CardHeaderPreviewPdf>
          </Grid>
          <Grid
            container
            sx={{ justifyContent: "space-between", width: "100%", height: "100%" }}
          >
            <Grid
              item
              xs={"auto"}
              // className={menu ? "col-dashboard active" : "col-dashboard"}
              sx={{ padding: "0px !important" }}
            >
              <CardBasicPdf2
                sx={{
                  minWidth: "420px",
                  maxWidth: "420px",
                  height: "100%",
                  padding: "0",
                  paddingTop: "8px",
                  minHeight: "600px",
                  maxHeight: "800px",
                }}
              >
                <BoxTheme
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                    p: 0
                  }}
                >
                  <Typography
                    sx={{
                      color: "#2c4992",
                      fontWeight: "bold",
                      fontSize: "0.8rem",
                      textAlign: "center",
                      marginBottom: "21px"
                    }}
                  >
                    Carteira
                  </Typography>
                  <BoxTheme
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "center",
                      height: "100%",
                      p: 0
                    }}
                  >
                    <BoxTheme
                      sx={{
                        height: "60%",
                        marginLeft: "15px",
                        display: "flex",
                        justifyContent: "center",
                        p: 0,
                        width: "96%"
                      }}
                    >
                      <BarChart data={report1}></BarChart>
                    </BoxTheme>
                    <TableDashboardPdf
                      data={report1}
                    ></TableDashboardPdf>
                  </BoxTheme>
                </BoxTheme>
              </CardBasicPdf2>
            </Grid>
            <Grid
              item
              xs={"auto"}
              // className={menu ? "col-dashboard active" : "col-dashboard"}
              sx={{ padding: "0px !important" }}
            >
              <CardBasicPdf
                sx={{
                  minWidth: "420px",
                  maxWidth: "420px",
                  height: "100%",
                  padding: "0",
                  paddingTop: "8px",
                  minHeight: "600px",
                  maxHeight: "800px",
                }}
              >
                <BoxTheme
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#2c4992",
                      fontWeight: "bold",
                      fontSize: "0.8rem",
                      textAlign: "center",
                    }}
                  >
                    Resultados
                  </Typography>
                  <BoxTheme
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <BoxTheme
                      overflow-x="scroll"
                      sx={{
                        width: "100%",
                        height: "60%",
                        maxHeight: "616px",
                        display: "flex",
                        justifyContent: "center",
                        maxWidth: "350px",
                      }}
                    >
                      <PieChart
                        dashboard="report2"
                        data={report3}
                      ></PieChart>
                    </BoxTheme>
                    <TableDashboardPdf
                      data={report3}
                    ></TableDashboardPdf>
                  </BoxTheme>
                </BoxTheme>
              </CardBasicPdf>
            </Grid>
            <Grid
              item
              xs={"auto"}
              // className={menu ? "col-dashboard active" : "col-dashboard"}
              sx={{ padding: "0px !important" }}
            >
              <CardBasicPdf
                sx={{
                  minWidth: "420px",
                  maxWidth: "420px",
                  height: "100%",
                  padding: "0",
                  paddingTop: "8px",
                  minHeight: "600px",
                  maxHeight: "800px",
                }}
              >
                <BoxTheme
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#2c4992",
                      fontWeight: "bold",
                      fontSize: "0.8rem",
                      textAlign: "center",
                    }}
                  >
                    Finalizados
                  </Typography>
                  <BoxTheme
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <BoxTheme
                      overflow-x="scroll"
                      sx={{
                        width: "100%",
                        height: "60%",
                        display: "flex",
                        justifyContent: "center",
                        maxWidth: "350px",
                      }}
                    >
                      <PieChart
                        dashboard="report3"
                        data={report2}
                      ></PieChart>
                    </BoxTheme>
                    <TableDashboardPdf
                      data={report2}
                    ></TableDashboardPdf>
                  </BoxTheme>
                </BoxTheme>
              </CardBasicPdf>
            </Grid>
          </Grid>
          <Box
            sx={{
              borderTop: 2,
              marginTop: "8px",
              marginLeft: "20px",
              marginRight: "20px",
              borderColor: "#01A7E1",
            }}
          ></Box>
          <Grid>
            <Typography sx={{ marginLeft: "35px" }}>
              Data da extração: {agora} | Extraído por : {userPdfEmit}
            </Typography>
          </Grid>
        </Box>
      </div>
    </Box >
  );
}
